export type lang = `${EnumLang}`;

export enum EnumLang {
  fr_FR = 'fr_FR',
  es_ES = 'es_ES',
  pt_BR = 'pt_BR',
  en_GB = 'en_GB',
  en_US = 'en_US',
  et_EE = 'et_EE',
  fi_FI = 'fi_FI',
  el_GR = 'el_GR',
  it_IT = 'it_IT',
  lt_LT = 'lt_LT',
  nb_NO = 'nb_NO',
  pt_PT = 'pt_PT',
  ru_RU = 'ru_RU',
  de_DE = 'de_DE',
  hu_HU = 'hu_HU',
  nl_NL = 'nl_NL',
}
